export const EMI_BANKS_ERROR_MESSAGE = 'Not able to load EMI options'
export const EMI_BANKS_RETRY_MESSAGE = 'Try again'
